import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import InsuredOccupation from '../../coverNoteCVComponent/insuredOccupation/InsuredOccupation';
import DrivingExperience from '../../coverNoteCVComponent/drivingExperience/DrivingExperience';
import Age from '../../coverNoteCVComponent/age/Age';
import HirePurchaseOwner from '../../coverNoteCVComponent/hirePurchaseOwner/HirePurchaseOwner';
import NameDrivers from '../../coverNoteCVComponent/nameDrivers/NameDrivers';

class InsuredAndDriverInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Insured and Driver Information</h3>
          <FormGroup controlId="">
            <Col sm={6}>
              <InsuredOccupation
                insuredOccupation={this.props.insuredAndDriverInfo.insuredOccupation}
                handleChangeInsuredOccupation={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <DrivingExperience
                drivingExperience={this.props.insuredAndDriverInfo.drivingExperience}
                handleChangeDrivingExperience={this.props.handleChangeInsuredAndDriverInfo}
                validation={this.props.validation}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <Age
                age={this.props.insuredAndDriverInfo.age}
                handleChangeAge={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
            <Col sm={6}>
              <HirePurchaseOwner
                hirePurchaseOwner={this.props.insuredAndDriverInfo.hirePurchaseOwner}
                handleChangeHirePurchaseOwner={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <NameDrivers
                nameDrivers={this.props.insuredAndDriverInfo.nameDrivers}
                handleChangeNameDrivers={this.props.handleChangeInsuredAndDriverInfo}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
      </div>
    )
  }
}

InsuredAndDriverInfo.propTypes = {
  insuredAndDriverInfo: PropTypes.object,
  handleChangeInsuredAndDriverInfo: PropTypes.func,
  validation: PropTypes.func
};

export default InsuredAndDriverInfo;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/insuredAndDriverInfo/InsuredAndDriverInfo.js